import { FC } from "react";

import { useTranslation } from "react-i18next";

import { createStyles, SimpleGrid, TextInput } from "@mantine/core";

import { Draft } from "@utils/Draft.util";
import { IAddress } from "@models/Address.model";
import { InputProps } from "@utils/InputProps.util";
import { PhoneNumberInput } from "@components/PhoneNumberInput/PhoneNumberInput";

const useStyles = createStyles((t) => ({
  grid: {
    gridTemplateColumns: "repeat(2, 1fr)",
    [`@media (max-width: ${t.breakpoints.xs}px)`]: {
      gridTemplateColumns: "1fr",
    },
  },
}));

export const AddressInput: FC<InputProps<Draft<IAddress>>> = ({
  city,
  phone,
  country,
  postCode,
  streetAndHouse,
}) => {
  const { t } = useTranslation();
  const { classes } = useStyles();
  return (
    <>
      <TextInput
        required
        label={t("Street and House Number")}
        {...streetAndHouse}
      />
      <SimpleGrid className={classes.grid}>
        <TextInput required label={t("Postal code / ZIP code")} {...postCode} />
        <TextInput required label={t("City")} {...city} />
        <TextInput required label={t("Country")} {...country} />
        <PhoneNumberInput {...phone} />
      </SimpleGrid>
    </>
  );
};
